import React, { memo } from 'react';

import Wrapper from './styles';

export const TablePlaceholder = ({ type }) => {
  if (type === 'mb') {
    return (
      type === 'mb' &&
      [1, 2, 3].map(el => (
        <tr key={el}>
          <td style={{ width: '104px', height: '48px' }}>
            <ContentPlaceholder style={{ width: '50%', height: '20px' }} />
          </td>
          <td style={{ width: '294px', height: '48px' }}>
            <ContentPlaceholder style={{ width: '50%', height: '20px' }} />
          </td>
          <td style={{ width: '294px', height: '48px' }}>
            <ContentPlaceholder style={{ width: '50%', height: '20px' }} />
          </td>
        </tr>
      ))
    );
  }
  return [1, 2, 3, 4].map(el => (
    <tr key={el}>
      <td style={{ width: '83px', height: '48px' }}>
        <ContentPlaceholder style={{ width: '50%', height: '20px' }} />
      </td>
      <td style={{ width: '104px', height: '48px' }}>
        <ContentPlaceholder style={{ width: '50%', height: '20px' }} />
      </td>
      <td style={{ width: '264px', height: '48px' }}>
        <ContentPlaceholder style={{ width: '50%', height: '20px' }} />
      </td>
      <td style={{ width: '241px', height: '48px' }}>
        <ContentPlaceholder style={{ width: '50%', height: '20px' }} />
      </td>
    </tr>
  ));
};

const ContentPlaceholder = memo(props => <Wrapper {...props} />);

export default ContentPlaceholder;
